export default "__VITE_ASSET__DtBNONSr__"